import { PairName } from '@ui/assets/config/trade-pair-listings';
import { TradePair } from '@ui/types/tradePair';

export const unifyTradePairs = (
  tradePairs: TradePair[] | readonly TradePair[],
) => {
  // Create a Map to keep track of unique baseName values
  const uniqueBaseNames = new Map<PairName, TradePair>();

  // Iterate over each trade pair
  tradePairs.forEach((tradePair) => {
    const existingPair = uniqueBaseNames.get(tradePair.baseName);

    // If there is no existing pair or the existing pair is a degen pair and the current pair is not, update the map
    if (!existingPair || (existingPair.isDegenPair && !tradePair.isDegenPair)) {
      uniqueBaseNames.set(tradePair.baseName, tradePair);
    }
  });

  // Return the array of unique trade pairs
  return Array.from(uniqueBaseNames.values());
};
